import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import { submitIntakeForm, imageUploadApi } from "../../services/api";

const IntakeFormPage15: React.FC = () => {
  interface FormData {
    // pid: string;
    // formReferenceID: string;
    mwl_modality: string;
    preferred_treatment: string;
    idealWeight: string;
    q1_do_any_of_these_health_conditions_or_situations_apply_to_you: string[];
    q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you: string[];
    // q1_do_any_of_these_apply_to_you: string[];
    q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss: string;
    q3_are_you_currently_gaining_or_re_gaining_weight: string;
    q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications: {
      name: "";
      dose: "";
      frequency: "";
      timeline: "";
    };
    q3_What_was_your_starting_weight_in_pounds_lbs: string;
    q3_What_is_your_current_weight_in_pounds_lbs: string;
    q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward: string;
    q3_When_was_your_last_dose_of_medication: string;
    q3_patient_image_url: string;
    q3_are_you_willing_to_restart_at_level_1: string;
    q4_Please_answer_the_following_regarding_your_medication_and_allergy_history: string[];
    q4_Please_include_name_dose_and_frequency_of_all_your_medications: {
      name: "";
      dose: "";
      frequency: "";
    };
    q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines: {
      date: "";
      name: "";
      dose: "";
      frequency: "";
    };
    q4_Please_provide_medication_allergie_details_including_name_and_reaction: {
      name: "";
      reaction: "";
    };
    q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries: string;
    q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery: {
      date: "";
      name: "";
    };
    q6_Which_of_the_following_lifestyle_factors_apply_to_you: string[];
    q6_please_provide_brief_details: string;
    q7_how_has_your_weight_changed_in_the_last_12_months: string;
    q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes: string;
    q8_What_was_your_most_recent_fasting_glucose_value: string;
    q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value: string;
    q9_what_is_your_current_or_average_blood_pressure_range: string;
    q10_what_is_your_current_or_average_resting_heart_rate_range: string;
    q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about: string[];
    q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately: string;
    q12_if_yes_please_mention: string;
    Are_you_currently_or_planning_for_any_of_the_following: string;
    Have_you_experienced_any_significant_medical_conditions_either_currently_or_in_the_past_that_could_impact_your_health_and_wellness_journey: string;
  }

  const syncStates = ["AR", "DC", "DE", "LA", "MS", "NM", "RI", "WV"];

  const [storedData, setStoredData] = useState<Record<string, any>>({});
  const [loader, setLoader] = useState(false);

  const [selectedOptionsQ1, setSelectedOptionsQ1] = useState<string[]>([]);
  const [selectedOptionsQ2, setSelectedOptionsQ2] = useState<string[]>([]);
  const [selectedOptionsQ3, setSelectedOptionsQ3] = useState<string[]>([]);
  const [selectedOptionsQ5, setSelectedOptionsQ5] = useState<string[]>([]);
  const [selectedOptionsQ10, setSelectedOptionsQ10] = useState<string[]>([]);
  const [uuidValue, setUuidValue] = useState<string>("");
  const [medicationType, setMedicationType] = useState("");
  const [itemName, setItemName] = useState("");
 
  const navigate = useNavigate();
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);

  useEffect(() => {
    const completeIntakeStep11 = localStorage.getItem("complete-intake-step11");
    if (completeIntakeStep11) {
      navigate("/complete-intake/step-12", { replace: true });
    } else {
      navigate("/complete-intake/step-11", { replace: true });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(storedData).length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        // pid:"2131517",
        // pid: storedData.patientId ? storedData.patientId.value : "",
        height: storedData.height ? storedData.height.value : "",
        weight: storedData.weight ? storedData.weight.value : "",
        idealWeight: storedData.idealWeight ? storedData.idealWeight.value : "",
        // BMI: storedData.bmi ? storedData.bmi.value : "",
        first_name: storedData.firstName ? storedData.firstName.value : "",
        last_name: storedData.lastName ? storedData.lastName.value : "",
        email: storedData.email ? storedData.email.value : "",
        phone_number: storedData.phone ? storedData.phone.value : "",
        email_subscribed: storedData.isSubscribed
          ? storedData.isSubscribed.value
          : "",
        uuid: storedData.uuid ? storedData.uuid.value : "",
        dob: storedData.dob ? storedData.dob.value : "",
        gender: storedData.gender ? storedData.gender.value : "",
        city: storedData.city ? storedData.city.value : "",
        line1: storedData.addressLine1 ? storedData.addressLine1.value : "",
        line2: storedData.addressLine2 ? storedData.addressLine2.value : "",
        state: storedData.state ? storedData.state.value : "",
        zip: storedData.zip ? storedData.zip.value : "",
        Are_you_currently_or_planning_for_any_of_the_following:
          storedData.isPlanningBaby ? storedData.isPlanningBaby.value : "",
        Have_you_experienced_any_significant_medical_conditions_either_currently_or_in_the_past_that_could_impact_your_health_and_wellness_journey:
          storedData.past_illness ? storedData.past_illness.value : "",
        q3_What_is_your_current_weight_in_pounds_lbs: storedData.weight
          ? storedData.weight.value
          : "",
        Are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medication_GLP1_or_non_GLP1_for_weight_loss:
          storedData.weight_loss_medication.value
            ? storedData.weight_loss_medication.value
            : "",
      }));
    }
  }, [storedData]);
  useEffect(() => {
    const savedItemName = localStorage.getItem("itemName");
    const savedMedicationType = localStorage.getItem("medicationType");
    if (savedItemName) {
      setItemName(savedItemName);
    }
    if (savedMedicationType) {
     
      setMedicationType(savedMedicationType);
    }
  },[])
  const [formData, setFormData] = useState<FormData>({
    // pid: "",
    // formReferenceID: "1172921",
    mwl_modality: "async_visit",
    preferred_treatment: "",
    idealWeight: "",
    q1_do_any_of_these_health_conditions_or_situations_apply_to_you: [],
    q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you:
      [],
    // q1_do_any_of_these_apply_to_you: [],
    q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss:
      "",
    q3_are_you_currently_gaining_or_re_gaining_weight: "",
    q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications:
      { name: "", dose: "", frequency: "", timeline: "" },
    q3_What_was_your_starting_weight_in_pounds_lbs: "",
    q3_What_is_your_current_weight_in_pounds_lbs: "",
    q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward:
      "",
    q3_When_was_your_last_dose_of_medication: "",
    q3_patient_image_url: "",
    q3_are_you_willing_to_restart_at_level_1: "",
    q4_Please_answer_the_following_regarding_your_medication_and_allergy_history:
      [],
    q4_Please_include_name_dose_and_frequency_of_all_your_medications: {
      name: "",
      dose: "",
      frequency: "",
    },
    q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines: {
      date: "",
      name: "",
      dose: "",
      frequency: "",
    },
    q4_Please_provide_medication_allergie_details_including_name_and_reaction: {
      name: "",
      reaction: "",
    },
    q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries:
      "",
    q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery:
      {
        date: "",
        name: "",
      },
    q6_Which_of_the_following_lifestyle_factors_apply_to_you: [],
    q6_please_provide_brief_details: "",
    q7_how_has_your_weight_changed_in_the_last_12_months: "",
    q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes: "",
    q8_What_was_your_most_recent_fasting_glucose_value: "",
    q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value: "",
    q9_what_is_your_current_or_average_blood_pressure_range: "",
    q10_what_is_your_current_or_average_resting_heart_rate_range: "",
    q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about:
      [],
    q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately:
      "",
    q12_if_yes_please_mention: "",
    Are_you_currently_or_planning_for_any_of_the_following: "",
    Have_you_experienced_any_significant_medical_conditions_either_currently_or_in_the_past_that_could_impact_your_health_and_wellness_journey:
      "",
  });

  const isFormValid = () => {
    // if (formData.q1_do_any_of_these_apply_to_you.length === 0) return false;

    if (
      formData.q1_do_any_of_these_health_conditions_or_situations_apply_to_you
        .length === 0
    )
      return false;

    if (
      formData
        .q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you
        .length === 0
    )
      return false;

    const q2Answer =
      formData.q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss?.trim();
    if (!q2Answer) return false;

    const medDetails =
      formData.q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications;

    if (
      q2Answer === "Yes, I currently take a GLP-1 medication for weight loss" ||
      q2Answer ===
        "Yes, I currently take another (non-GLP-1) medication for weight loss"
    ) {
      if (
        !medDetails.name ||
        !medDetails.dose ||
        !medDetails.frequency ||
        !medDetails.timeline
      )
        return false;
      if (!formData.q3_What_was_your_starting_weight_in_pounds_lbs)
        return false;
      if (
        !formData.q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward
      )
        return false;

      if (
        q2Answer === "Yes, I currently take a GLP-1 medication for weight loss"
      ) {
        if (!formData.q3_When_was_your_last_dose_of_medication) return false;
        if (
          formData.q3_When_was_your_last_dose_of_medication ===
            "More than 4 weeks ago" &&
          !formData.q3_are_you_willing_to_restart_at_level_1
        )
          return false;
      }
    }

    if (
      q2Answer ===
        "Yes, I have recently (within the last 12 months) taken a GLP-1 medication for weight loss" ||
      q2Answer ===
        "Yes, I have recently (within the last 12 months) taken another (non-GLP-1) medication for weight loss"
    ) {
      const gainingWeight =
        formData.q3_are_you_currently_gaining_or_re_gaining_weight;
      if (!gainingWeight) return false;

      if (gainingWeight === "Yes") {
        if (
          !medDetails.name ||
          !medDetails.dose ||
          !medDetails.frequency ||
          !medDetails.timeline
        )
          return false;
        if (!formData.q3_What_was_your_starting_weight_in_pounds_lbs)
          return false;
        if (
          !formData.q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward
        )
          return false;
        if (
          formData.q3_When_was_your_last_dose_of_medication ===
            "More than 4 weeks ago" &&
          !formData.q3_are_you_willing_to_restart_at_level_1
        )
          return false;
      }
    }

    if (
      q2Answer ===
      "No, I have taken medication(s) for weight loss before but it was over 12 months ago"
    ) {
      if (
        !medDetails.name ||
        !medDetails.dose ||
        !medDetails.frequency ||
        !medDetails.timeline
      )
        return false;
    }

    const q3Options =
      formData.q4_Please_answer_the_following_regarding_your_medication_and_allergy_history;
    if (q3Options.length === 0) return false;

    if (
      q3Options.includes(
        "I currently take prescription or over the counter medications."
      )
    ) {
      const meds =
        formData.q4_Please_include_name_dose_and_frequency_of_all_your_medications;
      if (!meds.name || !meds.dose || !meds.frequency) return false;
    }

    if (
      q3Options.includes(
        "I am currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs."
      )
    ) {
      const opiate =
        formData.q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines;
      if (!opiate.date || !opiate.name || !opiate.dose || !opiate.frequency)
        return false;
    }

    if (q3Options.includes("I have medication allergies.")) {
      const allergy =
        formData.q4_Please_provide_medication_allergie_details_including_name_and_reaction;
      if (!allergy.name || !allergy.reaction) return false;
    }

    const q4 =
      formData.q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries;
    if (!q4) return false;
    if (q4 === "Yes") {
      const surgery =
        formData.q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery;
      if (!surgery.date || !surgery.name) return false;
    }

    if (
      formData.q6_Which_of_the_following_lifestyle_factors_apply_to_you
        .length === 0
    )
      return false;

    if (
      formData.q6_Which_of_the_following_lifestyle_factors_apply_to_you.includes(
        "I have attempted to lose weight in a weight management program before, such as through caloric restriction, exercise, or behavior modification."
      ) &&
      !formData.q6_please_provide_brief_details
    )
      return false;

    if (!formData.q7_how_has_your_weight_changed_in_the_last_12_months)
      return false;

    if (
      !formData.q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes
    )
      return false;

    if (
      formData.q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes ===
      "Yes"
    ) {
      if (!formData.q8_What_was_your_most_recent_fasting_glucose_value)
        return false;
      if (!formData.q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value)
        return false;
    }

    if (!formData.q9_what_is_your_current_or_average_blood_pressure_range)
      return false;
    if (!formData.q10_what_is_your_current_or_average_resting_heart_rate_range)
      return false;

    if (
      formData
        .q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about
        .length === 0
    )
      return false;

    const q11 =
      formData.q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately;
    if (!q11) return false;
    if (q11 === "Yes" && !formData.q12_if_yes_please_mention) return false;

    return true;
  };

  useEffect(() => {
    const allValues: Record<string, any> = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allValues[key] = JSON.parse(value || "");
        } catch {
          allValues[key] = value;
        }
      }
    }
    setStoredData(allValues);
  }, []);

  const conditionsToCheck = [
    "Have given birth to a child within the last 6 months",
    "Inflammatory bowel disease or IBD (Crohn’s disease, ulcerative colitis, etc)",
    "Tumor/infection in brain/spinal cord",
    "Elevated resting heart rate (tachycardia)",
    "Coronary artery disease or heart attack/stroke in last 2 years",
    "Congestive heart failure",
    "Hospitalization within the last 1 year",
    "Seizures",
  ];

  const [imageError, setImageError] = useState<string>("");
  const [imageUploadUrl, setImageUploadUrl] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (imageError) {
      setImageError(imageError);
    }
  }, [imageError]);
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;

    setImageError("");
    if (!file) {
      setImageUploadUrl("");
      return;
    }

    try {
      const response = await imageUploadApi(file);
      setImageUploadUrl(response.image_url);
      setFormData((prevFormData) => ({
        ...prevFormData,
        q3_patient_image_url: response.image_url,
      }));
    } catch (error) {
      setImageError("Image upload failed. Try again");
      console.error("Error submitting the form:", error);
    }
  };

  const handleDeleteImage = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      q3_patient_image_url: "",
    }));
    setImageError("");
    setImageUploadUrl("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const calculateAge = (dobString: any) => {
    if (!dobString || typeof dobString !== "string") return NaN;
  
    const [month, day, year] = dobString.split("/").map(Number);
    if (!month || !day || !year) return NaN; // Invalid format
  
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
  
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const isEligibleToBookAppointment = () => {
    // if (itemName === "Semaglutide") {
    //   return true;
    // }
    // if (itemName === "Tirzepatide") {
    //   return true;
    // }
    if (syncStates.includes(storedData?.state?.value)) {
      return true;
    }
    const age = calculateAge(storedData.dob?.value);
    if (age >= 65 && age <= 74) {
      return true;
    }
    if (
      formData.q9_what_is_your_current_or_average_blood_pressure_range ===
      "≥140/90 (High Stage 2)"
    ) {
      return true;
    }
    if (
      formData.q10_what_is_your_current_or_average_resting_heart_rate_range ===
        "101-110 beats per minute (Slightly Fast)" ||
      formData.q10_what_is_your_current_or_average_resting_heart_rate_range ===
        ">110 beats per minute (Fast)"
    ) {
      return true;
    }
    if (
      formData[
        "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
      ] === "Yes, I currently take a GLP-1 medication for weight loss" ||
      formData[
        "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
      ] ===
        "Yes, I have recently (within the last 12 months) taken a GLP-1 medication for weight loss"
    ) {
      return true;
    }
    if (
      formData[
        "q4_Please_answer_the_following_regarding_your_medication_and_allergy_history"
      ].includes(
        "I am currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs."
      )
    ) {
      return true;
    }
    if (
      formData[
        "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries"
      ] === "Yes"
    ) {
      return true;
    }

    const q10Value =
      formData.q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about;
    if (Array.isArray(q10Value) && q10Value.includes("None of the above")) {
      return true;
    }
    if (
      formData[
        "q1_do_any_of_these_health_conditions_or_situations_apply_to_you"
      ] &&
      conditionsToCheck.some((condition) =>
        formData[
          "q1_do_any_of_these_health_conditions_or_situations_apply_to_you"
        ].includes(condition)
      )
    ) {
      return true;
    }

    if (
      formData[
        "q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you"
      ] &&
      conditionsToCheck.some((condition) =>
        formData[
          "q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you"
        ].includes(condition)
      )
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const isEligible = isEligibleToBookAppointment();
    setFormData((prevData) => ({
      ...prevData,
      mwl_modality: isEligible
          ? "sync_visit"
          : "async_visit",
    }));
  }, [storedData]);

  const exclusionList = [
    "Type 2 diabetes (on insulin)",
    "Type 1 diabetes",
    "Diabetic retinopathy (diabetic eye disease), damage to the optic nerve from trauma or reduced blood flow, or blindness",
    "Use of the blood thinner warfarin (Coumadin/Jantoven)",
    "History of or current pancreatitis",
  ];

  const isExcludedFromGLP1 = (): boolean => {
    return (
      formData.q1_do_any_of_these_health_conditions_or_situations_apply_to_you.some(
        (item) => exclusionList.includes(item)
      ) ||
      formData.q3_are_you_currently_gaining_or_re_gaining_weight === "No" ||
      formData.q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward ===
        "No"
    );
  };

  useEffect(() => {
    const isEligible = isEligibleToBookAppointment();  
    const mwl_modality = isEligible
        ? "sync_visit"
        : "async_visit";

    localStorage.setItem("mwl_modality", mwl_modality);
  }, [isEligibleToBookAppointment]);

  const preferredTreatment = () => {
  
    if (medicationType === "Injectable") {
      return `${itemName} Weekly Injection`;
    } else {
      return `${itemName} Daily Oral tablets`;
    }
  };

  const handleNext = async () => {
    if (!isFormValid()) {
      alert("Please fill all required fields.");
      return;
    }

    if(localStorage.getItem("intakeFormSubmitted") === "true"){
      navigate("/complete-intake/step-13");
      return;
    }

    try {
      const filteredData: Partial<FormData> = { ...formData };

      const userEmail = localStorage.getItem("email")
        ? JSON.parse(localStorage.getItem("email") as string).value
        : null;

      filteredData.preferred_treatment = preferredTreatment();

      if (formData.q3_patient_image_url === "") {
        filteredData.q3_patient_image_url = "support_follow_up";
      }

      if (
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] !==
          "No, I have taken medication(s) for weight loss before but it was over 12 months ago" &&
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] !== "No"
      ) {
        filteredData.q3_What_is_your_current_weight_in_pounds_lbs =
          storedData?.weight?.value;
      }

      if (
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] === "Yes, I currently take a GLP-1 medication for weight loss" ||
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] ===
          "Yes, I currently take another (non-GLP-1) medication for weight loss"
      ) {
        const q2Value = formData["q3_When_was_your_last_dose_of_medication"];

        if (["0-5 days", "6-10 days", "11-14 days"].includes(q2Value)) {
          delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
        } else if (q2Value === "More than 4 weeks ago") {
          delete filteredData["q3_patient_image_url"];
        } else if (
          q2Value === "More than 2 weeks ago but within the last 4 weeks"
        ) {
          delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
          delete filteredData["q3_patient_image_url"];
        }
        delete filteredData[
          "q3_are_you_currently_gaining_or_re_gaining_weight"
        ];
      }

      if (
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] ===
          "Yes, I have recently (within the last 12 months) taken a GLP-1 medication for weight loss" ||
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] ===
          "Yes, I have recently (within the last 12 months) taken another (non-GLP-1) medication for weight loss"
      ) {
        if (
          formData["q3_are_you_currently_gaining_or_re_gaining_weight"] === "No"
        ) {
          delete filteredData[
            "q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications"
          ];
          delete filteredData["q3_What_was_your_starting_weight_in_pounds_lbs"];
          delete filteredData["q3_What_is_your_current_weight_in_pounds_lbs"];
          delete filteredData[
            "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
          ];
          delete filteredData["q3_When_was_your_last_dose_of_medication"];
          delete filteredData["q3_patient_image_url"];
          delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
        }
        if (
          formData["q3_are_you_currently_gaining_or_re_gaining_weight"] ===
          "Yes"
        ) {
          delete filteredData["q3_When_was_your_last_dose_of_medication"];
          delete filteredData["q3_patient_image_url"];
          delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
        }
      }

      if (
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] ===
        "No, I have taken medication(s) for weight loss before but it was over 12 months ago"
      ) {
        delete filteredData["q3_What_was_your_starting_weight_in_pounds_lbs"];
        delete filteredData[
          "q3_are_you_currently_gaining_or_re_gaining_weight"
        ];
        delete filteredData["q3_What_is_your_current_weight_in_pounds_lbs"];
        delete filteredData[
          "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
        ];
        delete filteredData["q3_When_was_your_last_dose_of_medication"];
        delete filteredData["q3_patient_image_url"];
        delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
      }

      if (
        formData[
          "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
        ] === "No"
      ) {
        delete filteredData[
          "q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications"
        ];
        delete filteredData[
          "q3_are_you_currently_gaining_or_re_gaining_weight"
        ];
        delete filteredData["q3_What_was_your_starting_weight_in_pounds_lbs"];
        delete filteredData["q3_What_is_your_current_weight_in_pounds_lbs"];
        delete filteredData[
          "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
        ];
        delete filteredData["q3_When_was_your_last_dose_of_medication"];
        delete filteredData["q3_patient_image_url"];
        delete filteredData["q3_are_you_willing_to_restart_at_level_1"];
      }

      const q3Selections =
        formData[
          "q4_Please_answer_the_following_regarding_your_medication_and_allergy_history"
        ];

      if (q3Selections.includes("None of the above")) {
        delete filteredData[
          "q4_Please_include_name_dose_and_frequency_of_all_your_medications"
        ];
        delete filteredData[
          "q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines"
        ];
        delete filteredData[
          "q4_Please_provide_medication_allergie_details_including_name_and_reaction"
        ];
      } else {
        if (
          !q3Selections.includes(
            "I currently take prescription or over the counter medications."
          )
        ) {
          delete filteredData[
            "q4_Please_include_name_dose_and_frequency_of_all_your_medications"
          ];
        }

        if (
          !q3Selections.includes(
            "I am currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs."
          )
        ) {
          delete filteredData[
            "q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines"
          ];
        }

        if (!q3Selections.includes("I have medication allergies.")) {
          delete filteredData[
            "q4_Please_provide_medication_allergie_details_including_name_and_reaction"
          ];
        }
      }

      if (
        formData[
          "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries"
        ] === "No"
      ) {
        delete filteredData[
          "q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery"
        ];
      }

      if (
        formData[
          "q6_Which_of_the_following_lifestyle_factors_apply_to_you"
        ].includes("None of the above") ||
        formData[
          "q6_Which_of_the_following_lifestyle_factors_apply_to_you"
        ].includes(
          "I am willing to reduce my caloric intake alongside medication, if clinically appropriate."
        ) ||
        formData[
          "q6_Which_of_the_following_lifestyle_factors_apply_to_you"
        ].includes(
          "I am willing to increase my physical activity alongside medication, if clinically appropriate"
        )
      ) {
        delete filteredData["q6_please_provide_brief_details"];
      }

      if (
        formData[
          "q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes"
        ] === "No"
      ) {
        delete filteredData[
          "q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value"
        ];
        delete filteredData[
          "q8_What_was_your_most_recent_fasting_glucose_value"
        ];
      }

      if (
        formData[
          "q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately"
        ] === "No"
      ) {
        delete filteredData["q12_if_yes_please_mention"];
      }

      if (
        formData["Are_you_currently_or_planning_for_any_of_the_following"] ===
          "None of the Following" ||
        formData["Are_you_currently_or_planning_for_any_of_the_following"] ===
          ""
      ) {
        delete filteredData[
          "Are_you_currently_or_planning_for_any_of_the_following"
        ];
      }


      setLoader(true);
      const productCategory = "GLP1";
      const isEligible = isEligibleToBookAppointment();
      const isExcluded = isExcludedFromGLP1();
      const response = await submitIntakeForm(
        {
          ...filteredData,
          ...{
            mwl_modality: isEligible
                ? "sync_visit"
                : "async_visit",
          },
        },
        userEmail,
        productCategory,
        uuidValue
      );

      localStorage.setItem("intakeFormSubmitted", "true");
      if (isExcluded) {
        navigate("/complete-intake/disqualified");
      } else if (isEligible) {
        navigate("/complete-intake/step-13");
      } else {
        navigate("/complete-intake/thank-you");
      }
      localStorage.setItem("complete-intake-step12", "true");
    } catch (error) {
      console.error("Error submitting the form:", error);
    } finally {
      setLoader(false);
    }
  };

  const questionOneHealth = [
    "Type 2 diabetes (on insulin)",
    "Type 1 diabetes",
    "Diabetic retinopathy (diabetic eye disease), damage to the optic nerve from trauma or reduced blood flow, or blindness",
    "Use of the blood thinner warfarin (Coumadin/Jantoven)",
    "History of or current pancreatitis",
    "Have given birth to a child within the last 6 months",
    "Inflammatory bowel disease or IBD (Crohn’s disease, ulcerative colitis, etc)",
    "Personal or family history of thyroid cyst/nodule, thyroid cancer, medullary thyroid carcinoma, or multiple endocrine neoplasia syndrome type 2",
    "Gallbladder disease",
    "Seizures",
    "Glaucoma",
    "Gout",
    "Depression",
    "Head injury",
    "Tumor/infection in brain/spinal cord",
    "Low sodium",
    "Kidney disease",
    "Elevated resting heart rate (tachycardia)",
    "QT prolongation or other heart rhythm disorder",
    "Hospitalization within the last 1 year",
    "Human immunodeficiency virus (HIV)",
    "Constipation",
    "Hyperemesis gravidarum (nausea/vomiting in pregnancy)",
    "None of the above",
  ];

  const questionTwoWeightRelated = [
    "Hypertension (high blood pressure)",
    "Sleep apnea",
    "Prediabetes",
    "Type 2 diabetes (not on insulin)",
    "High cholesterol or triglycerides",
    "Acid reflux",
    "Asthma/reactive airway disease",
    "Urinary stress incontinence",
    "Polycystic ovarian syndrome (PCOS)",
    "Clinically proven low testosterone (male hypogonadism)",
    "Osteoarthritis",
    "Coronary artery disease or heart attack/stroke in last 2 years",
    "Congestive heart failure",
    "Liver disease, including fatty liver",
    "None of the above",
  ];

  const [questionTwoOptions, setQuestionTwoOptions] = useState<string[]>([]);

  useEffect(() => {
    const questionTwoOption = [
      "Yes, I currently take a GLP-1 medication for weight loss",
      "Yes, I currently take another (non-GLP-1) medication for weight loss",
      "Yes, I have recently (within the last 12 months) taken a GLP-1 medication for weight loss",
      "Yes, I have recently (within the last 12 months) taken another (non-GLP-1) medication for weight loss",
      ...(storedData.weight_loss_medication?.value === "No"
        ? [
            "No, I have taken medication(s) for weight loss before but it was over 12 months ago",
            "No",
          ]
        : ""),
    ];

    setQuestionTwoOptions(questionTwoOption);
  }, [storedData]);

  const questionTwoDOptions = ["Yes", "No"];

  const questionThreeEOptions = [
    "0-5 days",
    "6-10 days",
    "11-14 days",
    "More than 2 weeks ago but within the last 4 weeks",
    "More than 4 weeks ago",
  ];

  const questionsThreeOptions = [
    "I currently take prescription or over the counter medications.",
    "I am currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs.",
    "I have medication allergies.",
    "None of the above",
  ];

  const questionsFiveOptions = [
    "I have attempted to lose weight in a weight management program before, such as through caloric restriction, exercise, or behavior modification.",
    "I am willing to reduce my caloric intake alongside medication, if clinically appropriate.",
    "I am willing to increase my physical activity alongside medication, if clinically appropriate.",
    "None of the above",
  ];
  const questionThreeGOptions = ["Yes", "No"];

  const questionSixOptions = ["Yes", "No"];

  const questionSevenOptions = ["Yes", "No"];

  const questionsTenOptions = [
    "Loss of muscle mass while taking GLP-1/GIP medications such as semaglutide and tirzepatide",
    "Inability and/or unwillingness to inject yourself once weekly with GLP-1/GIP medications such as semaglutide and tirzepatide",
    "Side effects such as nausea/vomiting",
    "Aging and longevity (cellular/DNA damage, immune system dysfunction, etc)",
    "Cognitive function and mental clarity",
    "Low energy",
    "Desire to regulate menses and hormonal status",
    "Poor sleep quality",
    "None of the above",
  ];

  const questionNineOptions = [
    "Lost a significant amount",
    "Lost a little",
    "About the same",
    "Gained a little",
    "Gained a significant amount",
  ];

  const questionElevenOptions = [
    "<120/80 (Normal)",
    "120-129/<80 (Elevated)",
    "130-139/80-89 (High Stage 1)",
    "≥140/90 (High Stage 2)",
  ];

  const questionTwelveOptions = [
    "<60 beats per minute (Slow)",
    "60-100 beats per minute (Normal)",
    "101-110 beats per minute (Slightly Fast)",
    ">110 beats per minute (Fast)",
  ];
  const questionFourteenOptions = ["Yes", "No"];

  const [selectedRadio, setSelectedRadio] = useState<Record<string, string>>({
    "Do any of the following apply to you": "",
    "Are you currently taking or have recently taken medications for weight loss":
      "",
    "Have you taken any prescription medications to lose weight before": "",
    "Are you currently taking, plan to take, or have recently taken opiate pain medications and/or opiate-based street drugs":
      "",
    "Have you had prior bariatric weight loss surgery or any abdominal/pelvic surgeries":
      "",
    "Have you ever attempted to lose weight in a weight management program": "",
    "Are you willing to": "",
    "How has your weight changed in the last 12 months": "",
    "What is your current or average blood pressure range": "",
    "What is your current or average resting heart rate range": "",
  });

  const handleCheckboxChange = (option: string, questionKey: string) => {
    if (
      questionKey ===
      "q1_do_any_of_these_health_conditions_or_situations_apply_to_you"
    ) {
      setSelectedOptionsQ1((prev) => {
        let newSelectedOptions: string[];

        if (option === "None of the above") {
          newSelectedOptions = ["None of the above"];
        } else {
          newSelectedOptions = prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev.filter((item) => item !== "None of the above"), option];
        }

        setFormData((prevData) => ({
          ...prevData,
          [questionKey]: newSelectedOptions,
        }));

        return newSelectedOptions;
      });
    } else if (
      questionKey ===
      "q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you"
    ) {
      setSelectedOptionsQ2((prev) => {
        let newSelectedOptions: string[];

        if (option === "None of the above") {
          newSelectedOptions = ["None of the above"];
        } else {
          newSelectedOptions = prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev.filter((item) => item !== "None of the above"), option];
        }

        setFormData((prevData) => ({
          ...prevData,
          [questionKey]: newSelectedOptions,
        }));

        return newSelectedOptions;
      });
    } else if (
      questionKey ===
      "q4_Please_answer_the_following_regarding_your_medication_and_allergy_history"
    ) {
      setSelectedOptionsQ3((prev) => {
        let newSelectedOptions: string[];

        if (option === "None of the above") {
          newSelectedOptions = ["None of the above"];
        } else {
          newSelectedOptions = prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev.filter((item) => item !== "None of the above"), option];
        }

        setFormData((prevData) => ({
          ...prevData,
          [questionKey]: newSelectedOptions,
        }));

        return newSelectedOptions;
      });
    } else if (
      questionKey === "q6_Which_of_the_following_lifestyle_factors_apply_to_you"
    ) {
      setSelectedOptionsQ5((prev) => {
        let newSelectedOptions: string[];

        if (option === "None of the above") {
          newSelectedOptions = ["None of the above"];
        } else {
          newSelectedOptions = prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev.filter((item) => item !== "None of the above"), option];
        }

        setFormData((prevData) => ({
          ...prevData,
          [questionKey]: newSelectedOptions,
        }));

        return newSelectedOptions;
      });
    } else if (
      questionKey ===
      "q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about"
    ) {
      setSelectedOptionsQ10((prev) => {
        let newSelectedOptions: string[];

        if (option === "None of the above") {
          newSelectedOptions = ["None of the above"];
        } else {
          newSelectedOptions = prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev.filter((item) => item !== "None of the above"), option];
        }

        setFormData((prevData) => ({
          ...prevData,
          [questionKey]: newSelectedOptions,
        }));

        return newSelectedOptions;
      });
    }
  };

  const handleRadioChange = (name: string, value: string) => {
    setSelectedRadio((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "q3_When_was_your_last_dose_of_medication") {
      if (value !== "More than 4 weeks ago") {
        setFormData((prev) => ({
          ...prev,
          q3_are_you_willing_to_restart_at_level_1: "",
        }));
      }
    }

    if (
      name ===
      "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
    ) {
      setImageUploadUrl("");
      setImageError("");
      setSelectedRadio((prev) => ({
        ...prev,
        q3_are_you_currently_gaining_or_re_gaining_weight: "",
      }));
      setFormData((prev) => ({
        ...prev,
        q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications:
          {
            name: "",
            dose: "",
            frequency: "",
            timeline: "",
          },
        q3_What_was_your_starting_weight_in_pounds_lbs: "",
        q3_What_is_your_current_weight_in_pounds_lbs: "",
        q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward:
          "",
        q3_When_was_your_last_dose_of_medication: "",
        q3_patient_image_url: "",
        q3_are_you_willing_to_restart_at_level_1: "",
        q3_are_you_currently_gaining_or_re_gaining_weight: "",
      }));
    }

    if (value === "No") {
      if (name === "q3_are_you_currently_gaining_or_re_gaining_weight") {
        setFormData((prev) => ({
          ...prev,
          q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications:
            {
              name: "",
              dose: "",
              frequency: "",
              timeline: "",
            },
          q3_What_was_your_starting_weight_in_pounds_lbs: "",
          q3_What_is_your_current_weight_in_pounds_lbs: "",
          q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward:
            "",
        }));
      }
    }

    if (value === "No") {
      if (
        name ===
        "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries"
      ) {
        setFormData((prev) => ({
          ...prev,
          q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery:
            {
              date: "",
              name: "",
            },
        }));
      } else if (
        name ===
        "q6_have_you_ever_attempted_to_lose_weight_in_a_weight_management_program_such_as_through_caloric_restriction_exercise_or_behaviour_modification"
      ) {
        setFormData((prev) => ({
          ...prev,
          q6_if_so_please_provide_details: "",
        }));
      } else if (
        name ===
        "q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes"
      ) {
        setFormData((prev) => ({
          ...prev,
          q8_What_was_your_most_recent_fasting_glucose_value: "",
          q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value: "",
        }));
      } else if (
        name ===
        "q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately"
      ) {
        setFormData((prev) => ({
          ...prev,
          q12_if_yes_please_mention: "",
        }));
      }
    }

    if (name === "q3_When_was_your_last_dose_of_medication") {
      if (["0-5 days", "6-10 days", "11-14 days"].includes(value)) {
        setFormData((prevData) => ({
          ...prevData,
          q3_patient_image_url: "",
        }));
      }
    }

    // If "Other" is selected, clear the input field for that question
    if (value === "Other") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleMedicationDetailChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications:
        {
          ...prevData.q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications,
          [name]: value,
        },
    }));
  };

  const handlePrescriptionDetailChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      q4_Please_include_name_dose_and_frequency_of_all_your_medications: {
        ...prevData.q4_Please_include_name_dose_and_frequency_of_all_your_medications,
        [name]: value,
      },
    }));
  };

  const handleOpiateDetailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines:
        {
          ...prevData.q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines,
          [name]: value,
        },
    }));
  };

  const handleAllergiesDetailChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      q4_Please_provide_medication_allergie_details_including_name_and_reaction:
        {
          ...prevData.q4_Please_provide_medication_allergie_details_including_name_and_reaction,
          [name]: value,
        },
    }));
  };

  const handleBariatricDetailChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery:
        {
          ...prevData.q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery,
          [name]: value,
        },
    }));
  };

  const FilePreview = ({
    fileUrl,
    fileName,
  }: {
    fileUrl: string;
    fileName: string;
  }) => {
    const googleDocsViewer = `https://docs.google.com/gview?url=${fileUrl}&embedded=true&rm=minimal`;

    return (
      <iframe
        src={googleDocsViewer}
        width="100%"
        height="400px"
        style={{
          border: "none !important",
          background: "transparent",
          overflow: "hidden !important",
        }}
        title={`${fileName} Preview`}
        allowFullScreen
      ></iframe>
    );
  };

  // const allowOnlyLetters = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   if (!/[a-zA-Z0-9\- ]/.test(e.key) && e.key.length === 1) {
  //     e.preventDefault();
  //   }
  // };

  // const allowOnlyLettersAndNumbers = (
  //   e: React.KeyboardEvent<HTMLInputElement>
  // ) => {
  //   if (!/^[a-zA-Z0-9\s]$/.test(e.key) && e.key.length === 1) {
  //     e.preventDefault();
  //   }
  // };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <h1
            className="signup-intake-page-heading"
            style={{ textAlign: "left" }}
          >
            You are almost done.
          </h1>
          <h1
            className="signup-intake-page-heading2"
            style={{ textAlign: "left" }}
          >
            Just one last step!
          </h1>
          <h1
            className="signup-intro-para-second"
            style={{ textAlign: "left" }}
          >
            Please answer the below questions which will directly go to our
            doctors to review before they prescribe the GLP-1 to you.
          </h1>
          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q1. Do any of these health conditions or situations apply to you?
            </p>
            <div className="checkbox-container">
              {questionOneHealth.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={option}
                    onChange={() =>
                      handleCheckboxChange(
                        option,
                        "q1_do_any_of_these_health_conditions_or_situations_apply_to_you"
                      )
                    }
                    checked={selectedOptionsQ1.includes(option)}
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q2. Do any of the following weight-related medical conditions
              apply to you?
            </p>
            <div className="checkbox-container">
              {questionTwoWeightRelated.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={option}
                    onChange={() =>
                      handleCheckboxChange(
                        option,
                        "q2_do_any_of_the_following_weight_related_medical_conditions_apply_to_you"
                      )
                    }
                    checked={selectedOptionsQ2.includes(option)}
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q3. Are you currently taking or have recently (within the last 12
              months) taken medication(s) for weight loss?
            </p>
            <div className="checkbox-container">
              {questionTwoOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
                    value={option}
                    onChange={() =>
                      handleRadioChange(
                        "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss",
                        option
                      )
                    }
                    checked={
                      selectedRadio.q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss ===
                      option
                    }
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          {selectedRadio[
            "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
          ] === "Yes, I currently take a GLP-1 medication for weight loss" && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3a. Please list the name, dose, frequency, and timeline of
                  your weight loss medication(s).
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .name
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="dose"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .dose
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Dose"
                    maxLength={10}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="frequency"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .frequency
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Frequency"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="timeline"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .timeline
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Timeline"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3b. What was your starting weight in pounds (lbs)?
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="q3_What_was_your_starting_weight_in_pounds_lbs"
                    value={
                      formData.q3_What_was_your_starting_weight_in_pounds_lbs
                    }
                    onChange={handleInputChange}
                    placeholder="Starting weight"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3c. What is your current weight in pounds (lbs)?
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="q3_What_is_your_current_weight_in_pounds_lbs"
                    value={
                      formData.q3_What_is_your_current_weight_in_pounds_lbs ||
                      storedData.weight.value
                    }
                    readOnly
                    placeholder="Current weight"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3d. Do you agree to only obtain weight loss medication through
                  this platform moving forward?
                </p>
                <div className="checkbox-container">
                  {questionTwoDOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
                        value={option}
                        style={{ cursor: "pointer" }}
                        onChange={() =>
                          handleRadioChange(
                            "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward",
                            option
                          )
                        }
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3e. When was your last dose of medication? This question is
                  required before further medication can be prescribed.
                </p>
                <div className="checkbox-container">
                  {questionThreeEOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_When_was_your_last_dose_of_medication"
                        value={option}
                        onChange={() =>
                          handleRadioChange(
                            "q3_When_was_your_last_dose_of_medication",
                            option
                          )
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              {["0-5 days", "6-10 days", "11-14 days"].includes(
                selectedRadio["q3_When_was_your_last_dose_of_medication"]
              ) && (
                <div className="question-section" style={{ marginTop: "20px" }}>
                  <p className="sub-question">
                    3f. Please upload a picture of your current GLP-1 medication
                    pen or vial.
                  </p>
                  <input
                    type="file"
                    name="q3_patient_image_url"
                    ref={fileInputRef}
                    accept="image/*,.pdf,.docx"
                    onChange={handleImageUpload}
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginTop: "10px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      cursor: "pointer",
                    }}
                  />
                  {imageUploadUrl && (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "20px",
                      }}
                    >
                      {imageUploadUrl.endsWith(".pdf") ? (
                        <FilePreview
                          fileUrl={`${imageUploadUrl}`}
                          fileName="PDF"
                        />
                      ) : imageUploadUrl.endsWith(".docx") ? (
                        <FilePreview fileUrl={imageUploadUrl} fileName="DOCX" />
                      ) : (
                        <img
                          src={imageUploadUrl}
                          alt="Uploaded preview"
                          style={{ width: "100px", height: "auto" }}
                        />
                      )}
                      <button
                        onClick={handleDeleteImage}
                        style={{
                          position: "absolute",
                          top: "-12px",
                          right: "-12px",
                          backgroundColor: "#ff4d4d",
                          color: "#fff",
                          padding: "3px 6px",
                          borderRadius: "4px",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </div>
                  )}
                  {imageError && (
                    <p style={{ color: "red", marginTop: "5px" }}>
                      {imageError}
                    </p>
                  )}
                </div>
              )}
              {selectedRadio["q3_When_was_your_last_dose_of_medication"] ===
                "More than 4 weeks ago" && (
                <div className="question-section" style={{ marginTop: "20px" }}>
                  <p className="sub-question">
                    3g. If your last dose of GLP-1 medication was greater than 4
                    weeks ago, we restart the dose at level 1 (the lowest dose)
                    of medication. Are you willing to restart at level 1 (the
                    lowest dose) of medication?
                  </p>
                  <div className="checkbox-container">
                    {questionThreeGOptions.map((option, index) => (
                      <label key={index} className="checkbox-label">
                        <input
                          type="radio"
                          style={{ cursor: "pointer" }}
                          name="q3_are_you_willing_to_restart_at_level_1"
                          value={option}
                          onChange={() =>
                            handleRadioChange(
                              "q3_are_you_willing_to_restart_at_level_1",
                              option
                            )
                          }
                        />
                        <span>{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          {selectedRadio[
            "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
          ] ===
            "Yes, I currently take another (non-GLP-1) medication for weight loss" && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3a. Please list the name, dose, frequency, and timeline of
                  your weight loss medication(s).
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .name
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="dose"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .dose
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Dose"
                    maxLength={10}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="frequency"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .frequency
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Frequency"
                    maxLength={20}
                    
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="timeline"
                    value={
                      formData
                        .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                        .timeline
                    }
                    onChange={handleMedicationDetailChange}
                    placeholder="Timeline"
                    maxLength={20}
                    
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3b. What was your starting weight in pounds (lbs)?
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="q3_What_was_your_starting_weight_in_pounds_lbs"
                    value={
                      formData.q3_What_was_your_starting_weight_in_pounds_lbs
                    }
                    onChange={handleInputChange}
                    placeholder="Starting weight"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3c. What is your current weight in pounds (lbs)?
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="q3_What_is_your_current_weight_in_pounds_lbs"
                    value={
                      formData.q3_What_is_your_current_weight_in_pounds_lbs ||
                      storedData.weight.value
                    }
                    readOnly
                    placeholder="Current weight"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3d. Do you agree to only obtain weight loss medication through
                  this platform moving forward?
                </p>
                <div className="checkbox-container">
                  {questionTwoDOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
                        value={option}
                        style={{ cursor: "pointer" }}
                        onChange={() =>
                          handleRadioChange(
                            "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward",
                            option
                          )
                        }
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3e. When was your last dose of medication? This question is
                  required before further medication can be prescribed.
                </p>
                <div className="checkbox-container">
                  {questionThreeEOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_When_was_your_last_dose_of_medication"
                        value={option}
                        onChange={() =>
                          handleRadioChange(
                            "q3_When_was_your_last_dose_of_medication",
                            option
                          )
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>
              {["0-5 days", "6-10 days", "11-14 days"].includes(
                selectedRadio["q3_When_was_your_last_dose_of_medication"]
              ) && (
                <div className="question-section" style={{ marginTop: "20px" }}>
                  <p className="sub-question">
                    3f. Please upload a picture of your current GLP-1 medication
                    pen or vial.
                  </p>
                  <input
                    type="file"
                    name="q3_patient_image_url"
                    ref={fileInputRef}
                    accept="image/*,.pdf,.docx"
                    onChange={handleImageUpload}
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginTop: "10px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      cursor: "pointer",
                    }}
                  />
                  {imageUploadUrl && (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "20px",
                      }}
                    >
                      {imageUploadUrl.endsWith(".pdf") ? (
                        <FilePreview
                          fileUrl={`${imageUploadUrl}`}
                          fileName="PDF"
                        />
                      ) : imageUploadUrl.endsWith(".docx") ? (
                        <FilePreview fileUrl={imageUploadUrl} fileName="DOCX" />
                      ) : (
                        <img
                          src={imageUploadUrl}
                          alt="Uploaded preview"
                          style={{ width: "100px", height: "auto" }}
                        />
                      )}
                      <button
                        onClick={handleDeleteImage}
                        style={{
                          position: "absolute",
                          top: "-12px",
                          right: "-12px",
                          backgroundColor: "#ff4d4d",
                          color: "#fff",
                          padding: "3px 6px",
                          borderRadius: "4px",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </div>
                  )}
                  {imageError && (
                    <p style={{ color: "red", marginTop: "5px" }}>
                      {imageError}
                    </p>
                  )}
                </div>
              )}
              {selectedRadio["q3_When_was_your_last_dose_of_medication"] ===
                "More than 4 weeks ago" && (
                <div className="question-section" style={{ marginTop: "20px" }}>
                  <p className="sub-question">
                    3g. If your last dose of GLP-1 medication was greater than 4
                    weeks ago, we restart the dose at level 1 (the lowest dose)
                    of medication. Are you willing to restart at level 1 (the
                    lowest dose) of medication?
                  </p>
                  <div className="checkbox-container">
                    {questionThreeGOptions.map((option, index) => (
                      <label key={index} className="checkbox-label">
                        <input
                          type="radio"
                          style={{ cursor: "pointer" }}
                          name="q3_are_you_willing_to_restart_at_level_1"
                          value={option}
                          onChange={() =>
                            handleRadioChange(
                              "q3_are_you_willing_to_restart_at_level_1",
                              option
                            )
                          }
                        />
                        <span>{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          {selectedRadio[
            "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
          ] ===
            "Yes, I have recently (within the last 12 months) taken another (non-GLP-1) medication for weight loss" && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3a. Are you currently gaining/re-gaining weight?
                </p>
                <div className="checkbox-container">
                  {questionTwoDOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_are_you_currently_gaining_or_re_gaining_weight"
                        value={option}
                        style={{ cursor: "pointer" }}
                        onChange={() =>
                          handleRadioChange(
                            "q3_are_you_currently_gaining_or_re_gaining_weight",
                            option
                          )
                        }
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>

              {selectedRadio[
                "q3_are_you_currently_gaining_or_re_gaining_weight"
              ] === "Yes" && (
                <>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3b. Please list the name, dose, frequency, and timeline of
                      your weight loss medication(s).
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="name"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .name
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Medication name"
                        
                        maxLength={20}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="dose"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .dose
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Dose"
                        maxLength={10}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="frequency"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .frequency
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Frequency"
                        maxLength={20}
                        
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="timeline"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .timeline
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Timeline"
                        maxLength={20}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3c. What was your starting weight in pounds (lbs)?
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="q3_What_was_your_starting_weight_in_pounds_lbs"
                        value={
                          formData.q3_What_was_your_starting_weight_in_pounds_lbs
                        }
                        onChange={handleInputChange}
                        placeholder="Starting weight"
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3d. What is your current weight in pounds (lbs)?
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="q3_What_is_your_current_weight_in_pounds_lbs"
                        value={
                          formData.q3_What_is_your_current_weight_in_pounds_lbs ||
                          storedData.weight.value
                        }
                        readOnly
                        placeholder="Current weight"
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3e. Do you agree to only obtain weight loss medication
                      through this platform moving forward?
                    </p>
                    <div className="checkbox-container">
                      {questionTwoDOptions.map((option, index) => (
                        <label key={index} className="checkbox-label">
                          <input
                            type="radio"
                            name="q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
                            value={option}
                            style={{ cursor: "pointer" }}
                            onChange={() =>
                              handleRadioChange(
                                "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward",
                                option
                              )
                            }
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {selectedRadio[
            "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
          ] ===
            "Yes, I have recently (within the last 12 months) taken a GLP-1 medication for weight loss" && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  3a. Are you currently gaining/re-gaining weight?
                </p>
                <div className="checkbox-container">
                  {questionTwoDOptions.map((option, index) => (
                    <label key={index} className="checkbox-label">
                      <input
                        type="radio"
                        name="q3_are_you_currently_gaining_or_re_gaining_weight"
                        value={option}
                        style={{ cursor: "pointer" }}
                        onChange={() =>
                          handleRadioChange(
                            "q3_are_you_currently_gaining_or_re_gaining_weight",
                            option
                          )
                        }
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              </div>

              {selectedRadio[
                "q3_are_you_currently_gaining_or_re_gaining_weight"
              ] === "Yes" && (
                <>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3b. Please list the name, dose, frequency, and timeline of
                      your weight loss medication(s).
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="name"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .name
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Medication name"
                        
                        maxLength={20}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="dose"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .dose
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Dose"
                        maxLength={10}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="frequency"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .frequency
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Frequency"
                        maxLength={20}
                        
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        name="timeline"
                        value={
                          formData
                            .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                            .timeline
                        }
                        onChange={handleMedicationDetailChange}
                        placeholder="Timeline"
                        maxLength={20}
                        
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3c. What was your starting weight in pounds (lbs)?
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="q3_What_was_your_starting_weight_in_pounds_lbs"
                        value={
                          formData.q3_What_was_your_starting_weight_in_pounds_lbs
                        }
                        onChange={handleInputChange}
                        placeholder="Starting weight"
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3d. What is your current weight in pounds (lbs)?
                    </p>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                      <input
                        type="text"
                        name="q3_What_is_your_current_weight_in_pounds_lbs"
                        value={
                          formData.q3_What_is_your_current_weight_in_pounds_lbs ||
                          storedData.weight.value
                        }
                        readOnly
                        placeholder="Current weight"
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="question-section"
                    style={{ marginTop: "20px" }}
                  >
                    <p className="sub-question">
                      3e. Do you agree to only obtain weight loss medication
                      through this platform moving forward?
                    </p>
                    <div className="checkbox-container">
                      {questionTwoDOptions.map((option, index) => (
                        <label key={index} className="checkbox-label">
                          <input
                            type="radio"
                            name="q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward"
                            value={option}
                            style={{ cursor: "pointer" }}
                            onChange={() =>
                              handleRadioChange(
                                "q3_Do_you_agree_to_only_obtain_weight_loss_medication_through_this_platform_moving_forward",
                                option
                              )
                            }
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {selectedRadio[
            "q3_are_you_currently_taking_or_have_recently_within_the_last_12_months_taken_medications_for_weight_loss"
          ] ===
            "No, I have taken medication(s) for weight loss before but it was over 12 months ago" && (
            <div className="question-section" style={{ marginTop: "20px" }}>
              <p className="sub-question">
                3a. Please list the name, dose, frequency, and timeline of your
                weight loss medication(s).
              </p>
              <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                <input
                  type="text"
                  name="name"
                  value={
                    formData
                      .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                      .name
                  }
                  onChange={handleMedicationDetailChange}
                  placeholder="Medication name"
                  
                  maxLength={20}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  name="dose"
                  value={
                    formData
                      .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                      .dose
                  }
                  onChange={handleMedicationDetailChange}
                  placeholder="Dose"
                  maxLength={10}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  name="frequency"
                  value={
                    formData
                      .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                      .frequency
                  }
                  onChange={handleMedicationDetailChange}
                  placeholder="Frequency"
                  maxLength={20}
                  
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  name="timeline"
                  value={
                    formData
                      .q3_please_list_the_name_dose_frequency_and_timeline_of_your_weight_loss_medications
                      .timeline
                  }
                  onChange={handleMedicationDetailChange}
                  placeholder="Timeline"
                  maxLength={20}
                  
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
          )}

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q4. Please answer the following regarding your medication and
              allergy history:
            </p>
            <div className="checkbox-container">
              {questionsThreeOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={option}
                    onChange={() =>
                      handleCheckboxChange(
                        option,
                        "q4_Please_answer_the_following_regarding_your_medication_and_allergy_history"
                      )
                    }
                    checked={selectedOptionsQ3.includes(option)}
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          {selectedOptionsQ3.includes(
            "I currently take prescription or over the counter medications."
          ) && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  4(a)(i). Please include name, dose, and frequency of all your
                  medications.
                </p>
                <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q4_Please_include_name_dose_and_frequency_of_all_your_medications
                        .name
                    }
                    onChange={handlePrescriptionDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="dose"
                    value={
                      formData
                        .q4_Please_include_name_dose_and_frequency_of_all_your_medications
                        .dose
                    }
                    onChange={handlePrescriptionDetailChange}
                    placeholder="Dose"
                    maxLength={10}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="frequency"
                    value={
                      formData
                        .q4_Please_include_name_dose_and_frequency_of_all_your_medications
                        .frequency
                    }
                    onChange={handlePrescriptionDetailChange}
                    placeholder="Frequency"
                    maxLength={20}
                    
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
            </>
          )}
          {selectedOptionsQ3.includes(
            "I am currently taking, plan to take, or have recently (within the last 3 months) taken opiate pain medications and/or opiate-based street drugs."
          ) && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  4(b)(i). Please include date range, name, dose, and frequency.
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="date"
                    name="date"
                    value={
                      formData
                        .q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines
                        .date
                    }
                    onChange={handleOpiateDetailChange}
                    placeholder="Date"
                    min="1970-01-01"
                    max={new Date().toISOString().split("T")[0]}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines
                        .name
                    }
                    onChange={handleOpiateDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="dose"
                    value={
                      formData
                        .q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines
                        .dose
                    }
                    onChange={handleOpiateDetailChange}
                    placeholder="Dose"
                    maxLength={10}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="frequency"
                    value={
                      formData
                        .q4_please_include_date_name_dose_and_frequency_for_opiate_pain_medicines
                        .frequency
                    }
                    onChange={handleOpiateDetailChange}
                    placeholder="Frequency"
                    maxLength={20}
                    
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
            </>
          )}
          {selectedOptionsQ3.includes("I have medication allergies.") && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  4(c)(i). Please provide details including name and reaction.
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q4_Please_provide_medication_allergie_details_including_name_and_reaction
                        .name
                    }
                    onChange={handleAllergiesDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="reaction"
                    value={
                      formData
                        .q4_Please_provide_medication_allergie_details_including_name_and_reaction
                        .reaction
                    }
                    onChange={handleAllergiesDetailChange}
                    placeholder="Reaction"
                    
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
            </>
          )}
          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q5. Have you had prior bariatric (weight loss) surgery or any
              abdominal/pelvic surgeries?
            </p>
            <div className="checkbox-container">
              {questionSixOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="Have you had prior bariatric (weight loss) surgery or any abdominal/pelvic surgeries?"
                    value={option}
                    style={{ cursor: "pointer" }}
                    onChange={() =>
                      handleRadioChange(
                        "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries",
                        option
                      )
                    }
                    checked={
                      selectedRadio[
                        "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          {selectedRadio[
            "q5_have_you_had_prior_bariatric_weight_loss_surgery_or_any_abdominal_pelvic_surgeries"
          ] === "Yes" && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  5a. Please list all your prior bariatric (weight loss),
                  abdominal, and pelvic surgeries. Please include date range and
                  type of surgery.
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="date"
                    name="date"
                    value={
                      formData
                        .q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery
                        .date
                    }
                    onChange={handleBariatricDetailChange}
                    placeholder="Date"
                    min="1970-01-01"
                    max={new Date().toISOString().split("T")[0]}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    name="name"
                    value={
                      formData
                        .q5_please_list_all_your_prior_bariatric_weight_loss_abdominal_and_pelvic_surgeries_please_include_date_range_and_type_of_surgery
                        .name
                    }
                    onChange={handleBariatricDetailChange}
                    placeholder="Medication name"
                    
                    maxLength={20}
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q6. Which of the following lifestyle factors apply to you?
            </p>
            <div className="checkbox-container">
              {questionsFiveOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={option}
                    onChange={() =>
                      handleCheckboxChange(
                        option,
                        "q6_Which_of_the_following_lifestyle_factors_apply_to_you"
                      )
                    }
                    checked={selectedOptionsQ5.includes(option)}
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          {selectedOptionsQ5.includes(
            "I have attempted to lose weight in a weight management program before, such as through caloric restriction, exercise, or behavior modification."
          ) && (
            <>
              <div className="question-section" style={{ marginTop: "20px" }}>
                <p className="sub-question">
                  6(a)(i). Please provide brief details.
                </p>
                <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                  <input
                    type="text"
                    name="q6_please_provide_brief_details"
                    value={formData.q6_please_provide_brief_details}
                    onChange={handleInputChange}
                    placeholder="Please Specify"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q7. How has your weight changed in the last 12 months?
            </p>
            <div className="checkbox-container">
              {questionNineOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="How has your weight changed in the last 12 months?"
                    value={option}
                    onChange={() =>
                      handleRadioChange(
                        "q7_how_has_your_weight_changed_in_the_last_12_months",
                        option
                      )
                    }
                    style={{ cursor: "pointer" }}
                    checked={
                      selectedRadio[
                        "q7_how_has_your_weight_changed_in_the_last_12_months"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q8. Have you been diagnosed with prediabetes or type 2 diabetes?
            </p>
            <div className="checkbox-container">
              {questionSevenOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes"
                    value={option}
                    onChange={() =>
                      handleRadioChange(
                        "q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes",
                        option
                      )
                    }
                    style={{ cursor: "pointer" }}
                    checked={
                      selectedRadio[
                        "q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
            {selectedRadio[
              "q8_Have_you_been_diagnosed_with_prediabetes_or_type_2_diabetes"
            ] === "Yes" && (
              <>
                <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                  <p className="sub-question">
                    8a. What was your most recent fasting glucose value?
                  </p>
                  <input
                    type="text"
                    name="q8_What_was_your_most_recent_fasting_glucose_value"
                    value={
                      formData.q8_What_was_your_most_recent_fasting_glucose_value
                    }
                    onChange={handleInputChange}
                    maxLength={10}
                    placeholder="Glucose value"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      marginTop: "10px",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <p className="sub-question">
                    8b. What was your most recent hemoglobin A1c (HbA1c) value?
                  </p>
                  <input
                    type="text"
                    name="q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value"
                    value={
                      formData.q8_What_was_your_most_recent_hemoglobin_A1c_HbA1c_value
                    }
                    onChange={handleInputChange}
                    maxLength={10}
                    placeholder="Hemoglobin value"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      marginTop: "10px",
                    }}
                  />
                </div>
              </>
            )}
          </div>

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q9. What is your current or average blood pressure range?
            </p>
            <div className="checkbox-container">
              {questionElevenOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="What is your current or average blood pressure range?"
                    value={option}
                    style={{ cursor: "pointer" }}
                    onChange={() =>
                      handleRadioChange(
                        "q9_what_is_your_current_or_average_blood_pressure_range",
                        option
                      )
                    }
                    checked={
                      selectedRadio[
                        "q9_what_is_your_current_or_average_blood_pressure_range"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q10. What is your current or average resting heart rate range?
            </p>
            <div className="checkbox-container">
              {questionTwelveOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="What is your current or average resting heart rate range?"
                    value={option}
                    onChange={() =>
                      handleRadioChange(
                        "q10_what_is_your_current_or_average_resting_heart_rate_range",
                        option
                      )
                    }
                    style={{ cursor: "pointer" }}
                    checked={
                      selectedRadio[
                        "q10_what_is_your_current_or_average_resting_heart_rate_range"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q11. Based on your specific medical history and lifestyle, are you
              concerned about:
            </p>
            <div className="checkbox-container">
              {questionsTenOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={option}
                    onChange={() =>
                      handleCheckboxChange(
                        option,
                        "q11_Based_on_your_specific_medical_history_and_lifestyle_are_you_concerned_about"
                      )
                    }
                    checked={selectedOptionsQ10.includes(option)}
                    required
                    style={{ cursor: "pointer" }}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="question-section" style={{ marginTop: "20px" }}>
            <p className="question">
              Q12. Is there any further information which you would like the
              doctor to know? Please do not include urgent or emergency medical
              information here, as this is not reviewed immediately.
            </p>
            <div className="checkbox-container">
              {questionFourteenOptions.map((option, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="radio"
                    name="q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately"
                    value={option}
                    onChange={() =>
                      handleRadioChange(
                        "q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately",
                        option
                      )
                    }
                    style={{ cursor: "pointer" }}
                    checked={
                      selectedRadio[
                        "q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately"
                      ] === option
                    }
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>
          {selectedRadio[
            "q12_Is_there_any_further_information_which_you_would_like_the_doctor_to_know_Please_do_not_include_urgent_or_emergency_medical_information_here_as_this_is_not_reviewed_immediately"
          ] === "Yes" && (
            <div className="question-section" style={{ marginTop: "20px" }}>
              <input
                type="text"
                name="q12_if_yes_please_mention"
                value={formData["q12_if_yes_please_mention"]}
                onChange={handleInputChange}
                placeholder="Please Specify"
                style={{
                  width: "100%",
                  padding: "8px",
                  marginTop: "10px",
                  fontSize: "16px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
          )}

          <button
            className="next-btn"
            disabled={!isFormValid()}
            onClick={handleNext}
            style={{
              marginTop: "20px",
              backgroundColor: loader || !isFormValid() ? "#d3d3d3" : "#0c3972",
            }}
          >
            {loader ? "Loading..." : "Submit →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage15;
